<ng-container [formGroup]="formGroup()">
    <app-expansion-panel
        class="block max-w-full symbology-form-shadow rounded-md px-6 py-2 my-2"
        [isExpanded]="false">
        <p
            class="!m-0 text-xl"
            header>
            {{ title() }}
        </p>
        <div
            class="flex-1 overflow-x-auto min-h-0 pt-2"
            content>
            @if (isFormVisible() && formGroup()) {
                <div
                    class="grid gap-x-10 gap-y-2"
                    [class]="isWide() ? 'grid-cols-2' : 'grid-cols-1'">
                    <div>
                        <p class="text-sm text-custom-extra-dark-grey font-normal mb-1">
                            {{ 'commonSymbologySettings' | transloco }}
                        </p>

                        <app-symbology-base-form
                            [formGroup]="formGroup()"
                            [geometry]="geometry()"
                            [section]="SymbologyStyleScope.COMMON" />
                    </div>

                    <div>
                        <p class="text-sm text-custom-extra-dark-grey font-normal mb-1">
                            {{ 'specificSymbologySettings' | transloco }}
                        </p>

                        <app-symbology-base-form
                            [formGroup]="formGroup()"
                            [geometry]="geometry()"
                            [section]="SymbologyStyleScope.SPECIFIC" />

                        <app-symbology-label-form
                            class="grid grid-cols-2 gap-x-4 gap-y-0"
                            [formGroup]="labelForm"
                            (onLabelChange)="symbologyEditService.onChangeLabel($event, this.geometry())" />
                    </div>
                </div>
                <div class="text-right py-4">
                    <app-button
                        iconSize="sm"
                        [icon]="['fas', 'trash']"
                        [label]="'delete' | transloco"
                        [type]="ButtonType.ALERT_SECONDARY"
                        (onClick)="removeForm.emit()" />
                </div>
            } @else {
                <div class="container px-2 pt-2">{{ 'layerNotConcernedBySymbology' | transloco }}</div>
                <div class="text-right py-4">
                    <app-button
                        iconSize="sm"
                        [icon]="['fas', 'plus']"
                        [label]="'add' | transloco"
                        [type]="ButtonType.SECONDARY"
                        (onClick)="addForm.emit()" />
                </div>
            }
        </div>
    </app-expansion-panel>
</ng-container>
